import React from 'react'
import Homepage from './components/Homepage'
import Intro from './components/Intro'
import Footer from './components/Footer'
import Services from './components/Services'


function App() {

  return (
    <>
      <Homepage />
      <Services />
      <Intro />
      <Footer />
    </>
  );
}

export default App;
